import { clsx } from 'clsx';
import { Icon } from '../../../icon/Icon';
import { getDataIdsFromContract } from '../../utils/dataId';
import { GENERIC_STATUS_LABEL_DATA_ID_CONTRACT } from './data-ids';
import { GenericStatus } from '../../interfaces/generic-status';
import { STATUS_COLOR_MAP } from '../../constants';

export interface GenericStatusLabelProps<T> {
  status: GenericStatus<T>;
  className?: string;
  withIcon?: boolean;
  withPrefixComponent?: boolean;
  PrefixComponent?: React.ComponentType;
  prefixComponentProps?: object;
  withTextEllipsis?: boolean;
  fadedBadgeMode?: boolean;
}

export function GenericStatusLabel<T>({
  status,
  className,
  withIcon = true,
  withPrefixComponent = false,
  PrefixComponent,
  prefixComponentProps,
  withTextEllipsis = false,
  fadedBadgeMode = true
}: GenericStatusLabelProps<T>) {
  const dataIds = getDataIdsFromContract(GENERIC_STATUS_LABEL_DATA_ID_CONTRACT);

  const labelClasses = clsx(
    fadedBadgeMode
      ? [
          'badge badge-solid-faded badge-solid-faded-sm text-transform-none',
          `${STATUS_COLOR_MAP[status.colorType]}-badge`
        ]
      : 'center-flex-row',
    className
  );

  const textClasses = clsx(
    fadedBadgeMode ? '' : ['text-body-2', `text-${STATUS_COLOR_MAP[status.colorType]}`],
    withTextEllipsis && 'text-ellipsis'
  );

  return (
    <div className={labelClasses} data-id={dataIds.container}>
      {withPrefixComponent && PrefixComponent ? (
        <PrefixComponent {...prefixComponentProps} />
      ) : null}

      {withIcon ? (
        <Icon
          dataId={dataIds.icon}
          name={status.icon}
          className={`mr-1 text-${STATUS_COLOR_MAP[status.colorType]}`}
        />
      ) : null}

      <span data-id={dataIds.status} className={textClasses}>
        {status.displayName}
      </span>
    </div>
  );
}
